
import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/avatar.svg";
import Tilt from "react-parallax-tilt";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              ABOUT <span className="purple">MY WORK</span>
            </h1>

            <p className="home-about-body">
              I'm a Cybersecurity Engineer passionate about
              understanding how systems fail, identifying security
              weaknesses, and developing practical ways to improve
              security.
              <br />
              <br />
              My technical interests include
              <i>
                <b className="purple">
                  {" "}Vulnerability Research, Exploit Development,
                  Penetration Testing, and Security Tool Development.
                </b>
              </i>
              I enjoy investigating real-world security problems
              and learning how vulnerabilities can be identified,
              understood, and responsibly addressed.
              <br />
              <br />
              Beyond security assessments, I build hands-on labs
              and experiment with tools and technologies for
              <b className="purple">
                {" "}Security Operations, Threat Detection, and
                Network Security.
              </b>
              These projects help me turn technical concepts into
              practical experience.
              <br />
              <br />
              Through <b className="purple">Wilecurity</b>, I document
              my research, technical experiments, and projects.
              My goal is to keep learning, build useful security
              solutions, and contribute to a safer digital
              environment.
            </p>
          </Col>

          <Col md={4} className="myAvtar">
            <Tilt>
              <img
                src={myImg}
                className="img-fluid"
                alt="Portfolio illustration"
              />
            </Tilt>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Home2;
